function YoutubeEmbed (props) {
    const YoutubeID = props.YoutubeID;
    const src = 'https://www.youtube.com/embed/' + YoutubeID;
    const title = props.title;
    return (
      <div
        className="video"
        style={{
          position: "relative",
          paddingBottom: "56.25%",
          paddingTop: 25,
          height: 0
        }}
      >
        <iframe
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%"
          }}
          src={src}
          border="0"
          title={title}
          className="iframe"
        />
      </div>
    );
  };

export default YoutubeEmbed; 